import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
  HttpInterceptor,
  HttpResponse,
} from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { throwError } from "rxjs/internal/observable/throwError";

import { CookieService } from "ngx-cookie-service";
import { StorageService } from "../services/common/storage.service";
import * as moment from "moment";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import * as $ from "jquery";
import { TranslateService } from "@ngx-translate/core";

declare var wx: any;

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    public modalController: ModalController,
    public loadingController: LoadingController,
    public toastController: ToastController,
    public translateService: TranslateService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.getToken();
    const header = {};

    if (token) {
      header["Authentication"] = token;
    }

    const userId = localStorage.getItem("userId");
    if (userId) {
      header["userId"] = userId;
    }

    // 如果localStorage中有code，则把code放到header中
    const code = localStorage.getItem("code");
    if (code) {
      header["code"] = code;
    }

    // const _this = this;

    const authReq = request.clone({
      headers: new HttpHeaders(header),
    });

    return next.handle(authReq).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (event.body && event.body.code !== 0) {
            if (event.body.message) {
              console.log("event.body.message" + event.body.message);
            }
          }
        }
      }),
      catchError((error: any) => {
        // if (error.status === 401 && !request.url.includes("/login")) {
        if (error.status === 401) {
          if (error.error.message) {
            this.presentToast(error.error.message);
          }
          setTimeout(() => {
            wx.closeWindow();
          }, 2000);
          // alert('登录信息过期, 请重新登录!');
          // 路由跳转
          // this.router.navigate(['/page-tabs/tab5']);
          //   this.router.navigate(["/login"]);
          // 清除loading效果
          //   this.loadingController.dismiss({
          //     dismissed: true,
          //   });
          //   // 清除所有叠加的modal
          //   $(".show-modal").remove();
          // 提示token过期
          if (error.error.msg) {
            this.presentToast(error.error.msg);
          }
        }
        if (error.status === 500) {
          // 服务器500跳出报错信息
          alert(error.error.message);
        }
        if (error.status === 302) {
          window.location.href = error.error.redirectUrl;
          return;
        }
        return throwError(error);
      })
    );
  }

  // 获取token
  // getToken(): string {
  //     const token = localStorage.getItem('token');
  //     // const token = this.cookieService.get('token');
  //     if (token) {
  //         // this.cookieService.set('token', token, moment().add(30, 'm').toDate());
  //         localStorage.setItem('token', token);
  //         return token;
  //     } else {
  //         return '';
  //     }
  // }

  getToken(): string {
    const expiryTime = localStorage.getItem("expiryTime");
    if (expiryTime) {
      const now = moment().valueOf();
      const schExpiryTime = parseInt(expiryTime, 10);
      // console.log(now, typeof now, schExpiryTime, typeof schExpiryTime);
      if (now > schExpiryTime) {
        localStorage.removeItem("token");
        return "";
      } else {
        localStorage.setItem(
          "expiryTime",
          moment().add(30, "m").valueOf().toString()
        );
        const token = localStorage.getItem("token");
        return token;
      }
    }
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: this.translateService.instant(msg),
      duration: 2000,
      position: "top",
      cssClass: "toast_style",
      buttons: [],
    });
    toast.present();
  }
}
